(function (TransformationMobileAppLP, $) {
  const $dom = {};

  const transfFeaturesSliderOptions = {
    slidesToShow: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    prevArrow: $('[data-features-slider-prev]'),
    nextArrow: $('[data-features-slider-next]'),
  };

  const cacheDom = () => {
    $dom.transfFeaturesSlider = $('.js-transformation-mobile-app-features-slider-container');
    $dom.transfFaqTitle = $('.js-transformation-faq-submenu-title');
    $dom.transfFaqItem = $('.js-transformation-faq-submenu');
  };

  const initSliders = () => {
    $dom.transfFeaturesSlider.slick(transfFeaturesSliderOptions);
  };

  var bindUIActions = function () {
    $dom.transfFaqTitle.on('click', function () {
      if ($(this).parent().hasClass('is-active')) {
        $dom.transfFaqItem.removeClass('is-active');
        $dom.transfFaqItem.find('.circle-plus').removeClass('opened');
      } else {
        $dom.transfFaqItem.removeClass('is-active');
        $dom.transfFaqItem.find('.circle-plus').removeClass('opened');
        $(this).parent().addClass('is-active');
        $(this).parent().find('.circle-plus').toggleClass('opened');
      }
    });
  };

  TransformationMobileAppLP.init = function () {
    cacheDom();
    bindUIActions();
    initSliders();
  };
})((window.TransformationMobileAppLP = window.TransformationMobileAppLP || {}), jQuery);
